import React from 'react'
import { FocusableComponentLayout } from '@noriginmedia/norigin-spatial-navigation'
import tts from '../../lib/TTS'
import FocusableLink from '../../components/FocusableLink/index.ts'
import { SettingsChangeStationProps } from './types'
import PassportLink from './PassportLink.tsx'

const CHANGE_STATION = 'changeStationPanel'
const CHANGE_STATION_PATH = '/change-station'
const PASSPORT_ACTIVATE = 'passportPanelActivate'
const TITLE = 'Settings'

const SettingsChangeStation = ({
  callSign,
  handleFocus,
  passportEligible,
  passportUrl,
  shortCommonName,
  stationLogo,
  user,
}: SettingsChangeStationProps) => {
  const otherMemberships =
    user?.memberships?.filter(
      (m) => m.call_sign !== callSign && m.mvod_enabled
    ) || []

  const handleLinkFocus = (layout: FocusableComponentLayout) => {
    const accountSignoutTTS = `${TITLE}. Focused on ${shortCommonName} Change Station.`

    tts.stopRead()
    tts.addTextToRead(accountSignoutTTS)

    handleFocus?.(layout)
  }

  return (
    <div className="settings-section-container">
      <h2>{TITLE}</h2>

      <div className="settings-content">
        <FocusableLink
          focusKey={CHANGE_STATION}
          label={`${shortCommonName} Change Station`}
          onFocus={handleLinkFocus}
          to={CHANGE_STATION_PATH}
          disableTTS
        >
          <img
            alt={`${shortCommonName} logo`}
            className="station-logo"
            src={stationLogo}
          />
          <div className="change-station">Change Station</div>
        </FocusableLink>

        {passportEligible && (
          <PassportLink
            focusKey={PASSPORT_ACTIVATE}
            isActive={
              user.validPassportForCurrentStation ||
              (user.memberships?.some((m) => m.call_sign === callSign) ?? false)
            }
            label={`${shortCommonName} Passport`}
            onFocus={handleFocus}
            stationName={shortCommonName}
            to={passportUrl}
          />
        )}

        {otherMemberships.map((membership, i) => (
          <PassportLink
            key={`passportPanel-${i}`}
            focusKey={`passportPanel-${i}`}
            isActive={true}
            label={`${membership.call_sign} Passport`}
            onFocus={handleFocus}
            to={`/passport-upsell/${membership.call_sign}?membership=true`}
            stationName={membership.short_common_name}
          />
        ))}
      </div>
    </div>
  )
}

export default SettingsChangeStation
